import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ValidationInput from '../../../../shared/components/ValidationInput/ValidationInput'

class GateForm extends Component {

    render() {
        const props = this.props;

        return (
            <div className="container gate-form-container" style={{textAlign: "left"}}>
                <div className="row">
                    <div className="col-xs-12 col-md-10 col-md-offset-1">
                        <h3 className="pad-tp-xs"> First, enter some info about you and your bar so we can customize your report.</h3>
                        <p>We&rsquo;ll email you a summary with personalized recommendations so you&rsquo;ll have a record to reference or share.</p>
                    </div>
                    <div className="col-xs-12 col-md-1">
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12 col-md-5 col-md-offset-1 gate-form-input-row">
                        <ValidationInput
                            inputClassName={ "" }
                            label={ "First Name" }
                            value={ props.formData.firstName.value }
                            autoFocus={ false }
                            isValid={ props.formData.firstName.isValid }
                            errorMessage={ props.formData.firstName.errorMessage }
                            handleChange={ function (event) {
                                props.handleFormFieldValueChange("firstName", event.target.value);
                            }}
                            handleBlur={ function () {
                            }}
                            handleEnterClick={ function () {
                            }}
                        />
                    </div>
                    <div className="col-xs-12 col-md-5 gate-form-input-row">
                        <ValidationInput
                            inputClassName={ "" }
                            label={ "Last Name" }
                            value={ props.formData.lastName.value }
                            autoFocus={ false }
                            isValid={ props.formData.lastName.isValid }
                            errorMessage={ props.formData.lastName.errorMessage }
                            handleChange={ function (event) {
                                props.handleFormFieldValueChange("lastName", event.target.value);
                            }}
                            handleBlur={ function () {
                            }}
                            handleEnterClick={ function () {
                            }}
                        />
                    </div>
                    <div className="col-xs-12 col-md-1">
                    </div>
                </div>

                <div className="row gate-form-input-row">
                    <div className="col-xs-12 col-md-10 col-md-offset-1">
                        <ValidationInput
                            inputClassName={ "" }
                            label={ "Email" }
                            value={ props.formData.email.value }
                            autoFocus={ false }
                            isValid={ props.formData.email.isValid }
                            errorMessage={ props.formData.email.errorMessage }
                            handleChange={ function (event) {
                                props.handleFormFieldValueChange("email", event.target.value);
                            }}
                            handleBlur={ function () {
                            }}
                            handleEnterClick={ function () {
                            }}
                        />
                    </div>
                    <div className="col-xs-12 col-md-1">
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12 col-md-5 col-md-offset-1 gate-form-input-row">
                        <ValidationInput
                            inputClassName={ "" }
                            label={ "Phone Number" }
                            value={ props.formData.phoneNumber.value }
                            autoFocus={ false }
                            isValid={ props.formData.phoneNumber.isValid }
                            errorMessage={ props.formData.phoneNumber.errorMessage }
                            handleChange={ function (event) {
                                props.handleFormFieldValueChange("phoneNumber", event.target.value);
                            }}
                            handleBlur={ function () {
                            }}
                            handleEnterClick={ function () {
                            }}
                        />
                    </div>
                    <div className="col-xs-12 col-md-5 gate-form-input-row">
                        <ValidationInput
                            inputClassName={ "" }
                            label={ "Bar Zip Code" }
                            value={ props.formData.zipCode.value }
                            autoFocus={ false }
                            isValid={ props.formData.zipCode.isValid }
                            errorMessage={ props.formData.zipCode.errorMessage }
                            handleChange={ function (event) {
                                props.handleFormFieldValueChange("zipCode", event.target.value);
                            }}
                            handleBlur={ function () {
                            }}
                            handleEnterClick={ function () {
                            }}
                        />
                    </div>
                    <div className="col-xs-12 col-md-1">
                    </div>
                </div>

                <div className="row gate-form-input-row">
                    <div className="col-xs-12 col-md-10 col-md-offset-1">
                        <ValidationInput
                            inputClassName={ "" }
                            label={ "Bar Name" }
                            value={ props.formData.barName.value }
                            autoFocus={ false }
                            isValid={ props.formData.barName.isValid }
                            errorMessage={ props.formData.barName.errorMessage }
                            handleChange={ function (event) {
                                props.handleFormFieldValueChange("barName", event.target.value);
                            }}
                            handleBlur={ function () {
                            }}
                            handleEnterClick={ function () {
                            }}
                        />
                    </div>
                    <div className="col-xs-12 col-md-1">
                    </div>
                </div>

                <div className="row pad-bt-xs">
                    <div className="col-xs-12 col-md-10 col-md-offset-1">
                        <div className="bar-profit-select-wrapper">
                            <select
                                className={ "bar-profit-select" + (props.formData.barConnection.isValid ?  "" : " bar-profit-select-error")}
                                value={ props.formData.barConnection.value }
                                onChange={ function (event) {
                                    props.handleFormFieldValueChange("barConnection", event.target.value);
                                }}
                            >
                                {(props.formData.barConnection.value === "") ? <option key={0} value=""> </option> : ""}
                                <option key={1} value="Owner">Owner/Partner</option>
                                <option key={2} value="Beverage Director">Beverage Director</option>
                                <option key={3} value="General Manager">General Manager</option>
                                <option key={4} value="Bar Manager">Bar Manager</option>
                                <option key={5} value="Bartender">Bartender</option>
                                <option key={6} value="Consultant/Accountant">Consultant/Accountant</option>
                                <option key={7} value="I'd rather not disclose">I'd rather not disclose</option>
                                <option key={8} value="Other">Other</option>
                            </select>
                            <div className="bar-profit-select-arrow"></div>
                            <label className={(props.formData.barConnection.value === "") ? "bar-profit-select-label" : "bar-profit-select-label-active"}>
                                Job Title
                            </label>
                            <div className="bar-profit-select-error-text" style={{display : (props.formData.barConnection.isValid ? 'none' : 'block')}}>
                                { props.formData.barConnection.errorMessage }
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-1">
                    </div>
                </div>

                <div className="row spc-tp-xs">
                    <div className="col-xs-12 col-md-10 col-md-offset-1 text-right">
                        <span style={{cursor: "pointer"}}
                                className={"no-select"}
                                onClick={ function () {
                                    props.handleFormFieldValueChange("subscribeToBlog", !props.formData.subscribeToBlog.value);
                                }}
                        >
                            <input
                                id="subscribe-to-blog"
                                type="checkbox"
                                checked={ props.formData.subscribeToBlog.value }
                                onChange={ function (event) {
                                    props.handleFormFieldValueChange("subscribeToBlog", event.target.checked);
                                }}
                            />
                            <label className="bar-profit-subscribe-label">Subscribe to the blog</label>
                        </span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12 col-md-1">
                    </div>
                    <div className="col-xs-12 col-md-4 col-md-push-6 text-right">
                        { props.submitButton}
                    </div>
                    <div className="col-xs-12 col-md-6 col-md-pull-4 text-left">
                        { (props.errorMessage !== "") ?
                            <p className="bar-profit-gate-submit-error">{ props.errorMessage }</p> : ""
                        }
                    </div>
                </div>

            </div>
        );
    }
}

GateForm.propTypes = {
    formData: PropTypes.object.isRequired,
    errorMessage: PropTypes.string.isRequired,
    handleFormFieldValueChange: PropTypes.func.isRequired,
    submitButton: PropTypes.element.isRequired
};

export default GateForm;
